import React from 'react'

const HambMenu = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 3.33331H14" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M2 8H14" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
      <path d="M2 12.6667H14" stroke="white" stroke-width="1.5" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export default HambMenu;